<template>
  <router-link
    v-if="data"
    class="brands__item"
    :to="{ name: 'catalog', query: { brands_item_id: data.id } }"
    :title="data.title"
  >
    <ImgComponent :head_img="data.head_img" contain class="brands__item-img" />
  </router-link>
</template>

<script>
export default {
  name: "BrandItemComponent",
  props: {
    data: Object,
  },
};
</script>

<style lang="stylus">
.brands__item {
  border: 1px solid var(--gray);
  box-sizing: border-box;
  border-radius: var(--main_radius);
  height 80px
  background var(--white)
  overflow hidden
  display flex
  justify-content center
  align-items center
  cursor: pointer;
  padding 10px
  transition var(--transition)
  +below(540px) {
    height 70px
  }
  +below(420px) {
    height 60px
  }

  &:hover {
    border-color var(--main-color)
  }

  .file-icon {
    width 100%
    height auto
  }

  &-img {
    width 100%
    height 100%
    object-fit contain
    object-position center
  }
}
</style>
